/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import type { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Instagram',
  definitions: {
    '32': {
      viewBox: '0 0 33 32',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.6316 9.12896C12.8427 9.12896 9.76029 12.2114 9.76029 16.0002C9.76029 19.789 12.8427 22.8712 16.6316 22.8712C20.4205 22.8712 23.5029 19.789 23.5029 16.0002C23.5029 12.2114 20.4205 9.12896 16.6316 9.12896ZM16.6316 20.5051C14.1475 20.5051 12.1263 18.4842 12.1263 16.0001C12.1263 13.5158 14.1473 11.4948 16.6316 11.4948C19.1159 11.4948 21.1369 13.5158 21.1369 16.0001C21.1369 18.4842 19.1157 20.5051 16.6316 20.5051Z"
            fill="currentColor"
          />
          <path
            d="M22.5654 7.63064C22.8874 7.30729 23.3352 7.12274 23.791 7.12274C24.2484 7.12274 24.6964 7.30729 25.0182 7.63064C25.3415 7.95241 25.5261 8.40037 25.5261 8.8578C25.5261 9.31364 25.3415 9.7616 25.0182 10.085C24.6948 10.4067 24.2484 10.5928 23.791 10.5928C23.3352 10.5928 22.8872 10.4067 22.5654 10.085C22.2421 9.7616 22.056 9.3138 22.056 8.8578C22.056 8.40037 22.2419 7.95241 22.5654 7.63064Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.6057 2.66663H10.6572C6.59952 2.66663 3.29834 5.96796 3.29834 10.0256V21.9741C3.29834 26.032 6.59952 29.3331 10.6572 29.3331H22.6057C26.6637 29.3331 29.9648 26.0318 29.9648 21.9741V10.0256C29.965 5.96796 26.6637 2.66663 22.6057 2.66663ZM27.599 21.9741C27.599 24.7274 25.3591 26.9672 22.6059 26.9672H10.6572C7.90412 26.9673 5.66432 24.7274 5.66432 21.9741V10.0256C5.66432 7.27256 7.90412 5.03261 10.6572 5.03261H22.6057C25.3589 5.03261 27.5989 7.27256 27.5989 10.0256L27.599 21.9741Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
